import React from "react";

import dayjs from "dayjs";

import BusinessRuleTooltip from "./Reporting/TrustRules/SurvivorshipDomainRecord/InformationCard/BusinessRuleTooltip";
import { valueTag } from "./Reporting/TrustRules/utils";

export const generateSQLQuery = (values, checkingSQLValidity = false) => {
  const columns = values.namekey.map(key => `${key.value}`).join(", ");
  const aggregates = values.valuekey.length
    ? values.valuekey
        .map(key => {
          if (
            key.value.toUpperCase().includes(" AS ") ||
            key.value.includes('"')
          ) {
            return `${key.value}`;
          }

          return `${key.value} AS "${key.value}"`;
        })
        .join(", ")
    : "";
  const filters = values.filters.length
    ? ` WHERE ${values?.filters?.map(filter => filter.label).join("AND ")}`
    : "";
  const groupBy = values?.namekey
    ?.map(key => key.value.split(/ as /gi)?.[1] || key.value)
    .join(", ");

  let orderBy;
  if (
    values.chart_type.value === "pie" &&
    values.chart_type.value === "radar"
  ) {
    orderBy = "";
  } else if (values.chart_type.value === "tabular" && !values.valuekey.length) {
    orderBy = "";
  } else if (values.chart_type.value === "funnel") {
    orderBy = ` ORDER BY "${values.valuekey[0].value}" DESC`;
  } else {
    orderBy = ` ORDER BY "${
      values.sortBy.length
        ? values.sortBy[0].value
        : values.valuekey[0].value.split(/ as /gi)?.[1]?.replace(/"/g, "") ||
          values.valuekey[0].value
    }" ${values.sortDirection ? "DESC" : "ASC"}`;
  }

  return `SELECT ${columns}${
    values.valuekey.length ? ", " : ""
  }${aggregates} FROM ${values.schema.value}.${
    values.table.value
  }${filters} GROUP BY ${groupBy}${orderBy} LIMIT ${
    checkingSQLValidity ? 10 : values.row_limit.value
  };`;
};

export const initializeLayout = (chart, layouts) => {
  const y =
    layouts?.md && Math.max(...layouts.md.map(prevChart => prevChart["y"]));
  const prevY = y || -2;

  return {
    i: chart.id,
    x: 0,
    y: prevY + 2,
    w: chart.chart_type === "pie" ? 2 : 4,
    h: 2,
  };
};

export const abbreviateNumber = value => {
  var newValue = value;
  if (value >= 1000) {
    var suffixes = ["", "K", "M", "B", "T"];
    var suffixNum = Math.floor(`${value}`.length / 3);
    var shortValue = "";
    for (var precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat(
        (suffixNum !== 0
          ? value / Math.pow(1000, suffixNum)
          : value
        ).toPrecision(precision)
      );
      var dotLessShortValue = `${shortValue}`.replace(/[^a-zA-Z 0-9]+/g, "");
      if (dotLessShortValue.length <= 2) {
        break;
      }
    }
    if (shortValue % 1 !== 0) shortValue = shortValue.toFixed(1);
    newValue = shortValue + suffixes[suffixNum];
  }

  return newValue;
};

export const getUtcTime = time =>
  dayjs.utc(time).format("YYYY-MM-DD hh:mm:ss A");

export const survivorshipDomainRecordDetailsTableColumns = (
  columns,
  businessRules
) => {
  const SOURCE_SYSTEM_NAMES = {
    cvo_aperture: "CVO Aperture",
    morrisey: "Morrisey",
    provider_manager: "Provider Manager",
    ahcccs: "AHCCCS",
    nppes: "NPPES",
    fortis: "Fortis",
    apogee: "Apogee",
    msow: "MSOW",
  };

  const sourceSytemColumns = columns
    .filter(item => item !== "truth_system_value")
    .map((column, idx) => ({
      dataIndex: column,
      key: column,
      title: SOURCE_SYSTEM_NAMES[column] ?? column.replaceAll("_", " "),
      width: idx ? 220 : 260,
      render: values => valueTag(values),
    }));

  return [
    {
      dataIndex: "cde",
      key: "cde",
      width: 325,
      ellipsis: true,
      fixed: "left",
      render: (cellData, record) => {
        if (!record?.children) {
          return (
            <BusinessRuleTooltip businessRule={businessRules?.[cellData]}>
              <span>{cellData}</span>
            </BusinessRuleTooltip>
          );
        }

        return cellData;
      },
    },
    ...sourceSytemColumns,
  ];
};

export const stringifyFilters = filters =>
  Object.entries(filters)
    .filter(([, filterValue]) => filterValue)
    .map(([filterName, filterValue]) => `${filterName}='${filterValue}'`)
    .join(" and ");
